import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import HostelSidebar from './HostelSidebar';
import HostelHeader  from './HostelHeader';

const style = `
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  html, body, #root { height:100%; width:100%; }

  .h-layout-root    { display:flex; height:100vh; width:100vw; overflow:hidden; background:#f0f2f7; position:relative; }
  .h-layout-sidebar {
    flex-shrink:0; width:240px; height:100vh;
    overflow-y:auto; overflow-x:hidden; transition:transform .25s ease;
    scrollbar-width:thin;
    scrollbar-color:#2a2f4e #0f1123;
  }
  .h-layout-sidebar::-webkit-scrollbar { width:4px; }
  .h-layout-sidebar::-webkit-scrollbar-thumb { background:#2a2f4e; border-radius:99px; }
  .h-layout-sidebar::-webkit-scrollbar-track { background:#0f1123; }
  .h-layout-body    { flex:1; display:flex; flex-direction:column; height:100vh; overflow:hidden; min-width:0; }
  .h-layout-header  { flex-shrink:0; }
  .h-layout-main    { flex:1; overflow-y:auto; overflow-x:hidden; padding:24px; scrollbar-width:thin; scrollbar-color:#dde1ef transparent; }
  .h-layout-main::-webkit-scrollbar { width:5px; }
  .h-layout-main::-webkit-scrollbar-thumb { background:#dde1ef; border-radius:99px; }

  .h-sidebar-backdrop { display:none; position:fixed; inset:0; background:rgba(0,0,0,.5); z-index:199; }

  @media (max-width:768px) {
    .h-layout-main { padding:16px; }
    .h-layout-sidebar {
      position:fixed; left:0; top:0; bottom:0; z-index:200;
      transform:translateX(-100%);
    }
    .h-layout-sidebar.open {
      transform:translateX(0);
      box-shadow:4px 0 24px rgba(0,0,0,.3);
    }
    .h-sidebar-backdrop.open { display:block; }
  }
`;

const HostelLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <>
      <style>{style}</style>
      <div className="h-layout-root">
        <div className={`h-sidebar-backdrop ${sidebarOpen?'open':''}`} onClick={()=>setSidebarOpen(false)} />
        <div className={`h-layout-sidebar ${sidebarOpen?'open':''}`}>
          <HostelSidebar onClose={()=>setSidebarOpen(false)} />
        </div>
        <div className="h-layout-body">
          <div className="h-layout-header">
            <HostelHeader onMenuClick={()=>setSidebarOpen(o=>!o)} />
          </div>
          <main className="h-layout-main"><Outlet /></main>
        </div>
      </div>
    </>
  );
};

export default HostelLayout;
